import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import DOMPurify from 'dompurify'

import { defaultTimeZoneFormat, parseFlexibleDate } from '@hapana/shared/utils/date.util'
import { useSiteConfiguration } from '@hapana/shared/web/hooks/siteConfiguration.hooks'

import { styles } from './notes-properties.styles'

const NoteAlert = ({ description, date }) => {
  const { data } = useSiteConfiguration()
  const sanitizedHtml = { __html: DOMPurify.sanitize(description) }
  const parsedDate = parseFlexibleDate(date)
  return (
    <Box sx={styles.notesContainer}>
      <Box>
        <Typography
          typography="medium"
          color="gray.80"
          sx={styles.noteHtmlClamp}
          dangerouslySetInnerHTML={sanitizedHtml}
        />
        {parsedDate && (
          <Typography typography="small" color="gray.64" sx={styles.date}>
            {defaultTimeZoneFormat(parsedDate, data?.timezone)}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default NoteAlert

NoteAlert.propTypes = {
  description: PropTypes.string,
  date: PropTypes.string,
}

NoteAlert.defaultProps = {
  property: '',
  description: '',
}
